import PropTypes from "prop-types";

import { userPropType } from "@/view/viewPropTypes";
import { popoutContainerCss } from "../../SecondaryActions.style";
import CreateNewTextSet from "./CreateNewTextSet";
import UpdateTextSetOptions from "./UpdateTextSetOptions";

const propTypes = {
  contentId: PropTypes.string,
  contentType: PropTypes.string,
  currentLevel: PropTypes.shape({
    id: PropTypes.string,
    language: PropTypes.string,
  }),
  isMobile: PropTypes.bool,
  user: userPropType,
};

const AddOptions = ({
  contentId,
  contentType,
  currentLevel,
  isMobile,
  user,
}) => {
  const renderPopOutOptions = () => {
    return (
      <>
        <CreateNewTextSet
          contentId={contentId}
          contentType={contentType}
          currentLevel={currentLevel}
          user={user}
        />
        <UpdateTextSetOptions
          contentId={contentId}
          contentType={contentType}
          currentLevel={currentLevel}
        />
      </>
    );
  };

  if (isMobile) return renderPopOutOptions();

  return (
    <ul role="list" css={popoutContainerCss}>
      {renderPopOutOptions()}
    </ul>
  );
};

AddOptions.propTypes = propTypes;

export default AddOptions;
